const renderInline = (text, keyBase) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**")
      ? <strong key={`${keyBase}-${i}`} className="font-semibold text-slate-900">{part.slice(2, -2)}</strong>
      : part
  );

export function Markdown({ text = "" }) {
  const blocks = [];
  let list = null;
  text.split("\n").forEach((raw, i) => {
    const line = raw.trimEnd();
    const ul = line.match(/^[-*]\s+(.*)/);
    const ol = line.match(/^\d+\.\s+(.*)/);
    if (ul || ol) {
      const type = ul ? "ul" : "ol";
      if (!list || list.type !== type) {
        list = { type, items: [] };
        blocks.push(list);
      }
      list.items.push((ul || ol)[1]);
      return;
    }
    list = null;
    if (!line.trim()) return;
    if (line.startsWith("## ")) blocks.push({ type: "h3", text: line.slice(3) });
    else if (line.startsWith("# ")) blocks.push({ type: "h2", text: line.slice(2) });
    else blocks.push({ type: "p", text: line });
  });
  return (
    <div className="space-y-4 text-base leading-relaxed text-slate-700" data-testid="lesson-markdown">
      {blocks.map((b, i) => {
        if (b.type === "h2") return <h2 key={i} className="pt-2 text-2xl font-bold text-slate-900">{renderInline(b.text, i)}</h2>;
        if (b.type === "h3") return <h3 key={i} className="pt-2 text-xl font-semibold text-slate-900">{renderInline(b.text, i)}</h3>;
        if (b.type === "p") return <p key={i}>{renderInline(b.text, i)}</p>;
        const Tag = b.type;
        return (
          <Tag key={i} className={`space-y-1.5 pl-6 ${b.type === "ul" ? "list-disc" : "list-decimal"}`}>
            {b.items.map((it, j) => <li key={j}>{renderInline(it, `${i}-${j}`)}</li>)}
          </Tag>
        );
      })}
    </div>
  );
}
